export default function Arrow({ diagonal = false }: { diagonal?: boolean }) {
  return <svg aria-hidden="true" viewBox="0 0 32 32" fill="none" className={`arrow-icon ${diagonal ? 'arrow-diagonal' : ''}`}><path d="M4 16h23M19 8l8 8-8 8" stroke="currentColor" strokeWidth="1.4" /></svg>;
}
